export default {"src":"/_next/static/media/explore-withOut-content.dc79e066.svg","height":341,"width":502,"blurWidth":0,"blurHeight":0};